<template>
  <el-popover placement="top-start" width="400" trigger="click" visible-arrow="true" title="常用语"> 
    <div class="list">
     
      <ul>
        <li class="head" @click="showAdd=true"> <img src="@/assets/chat-img/add-changyongyu.png"/>新增常用语</li>
        <li class="head" v-if="showAdd">
          <el-input v-model="word" placeholder="请填写常用语"></el-input>
          <el-button type="primary" @click="add">保存</el-button>
          <el-button @click="showAdd=false">取消</el-button>

        </li>
        <li class="unit"  v-for="(item, index) in words" :key="index">
          <p @click="quikSend(item.content)"> {{item.content}}</p>
          <img src="@/assets/chat-img/del_reply.png" class="del" @click="del(item.com_id)"/>
        </li>
      
      </ul>
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import { wordList,addWord,delWord} from "@/api/chat/index";


export default {
  name: "QuickReply",
  
  data() {
    return {
      word:"",
      showAdd:false,
      words:[],
    };
  },
  mounted(){
    this.initList();
  },
  methods: {
    initList(){
      var that = this;
      wordList({}).then((response) => {
        that.words = response.data.data;
      });
    },
    quikSend(word){
      this.$emit("quikSend",word);
    },
    del(com_id){
      var that = this;
      delWord({"com_id":com_id}).then((response) => {
        if(response.code==200){
          that.initList();
        }else{
          that.$message.error(response.msg?response.msg:"删除失败")
        }
      });
    },
    add(){
      var that = this;
      addWord({"content":this.word}).then((response) => {
        if(response.code==200){
          that.initList();
          that.showAdd=false;
          that.word="";
        }else{
          that.$message.error(response.msg?response.msg:"添加失败")
        }
      });
    }
   
  },
};
</script>


<style lang="scss" scoped>
.list {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;


  .head{
    color: #4c71db;
    display: flex;
    align-items: center;
    img{
      width:20px;
    }
  }
  ul{
    flex-wrap: wrap;
    width: 400px;
    min-height: 140px;

    }

  ul li{
    color: #666666;
    font-size: 12px;
    padding: 10px;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover{
      background: #EEF2FF;
    }

   
  }
  ul  .unit{
    position: relative;
    border-bottom: 1px solid #f1f1f1;
    .del{
      position: absolute;
      right: 20px;
      width:20px;
      z-index:9;
      top: 50%;
    /* left: 50%; */
    transform: translate(-50%,-50%);

    }
  }
}

</style>
